export default function isInsideIframe() {
  return window.parent !== window.self || navigator.userAgent.toLocaleLowerCase().includes('android');
}
